import { render } from "./EditPrintTemplate.vue?vue&type=template&id=037347b4&scoped=true"
import script from "./EditPrintTemplate.vue?vue&type=script&lang=js"
export * from "./EditPrintTemplate.vue?vue&type=script&lang=js"

import "./EditPrintTemplate.vue?vue&type=style&index=0&id=037347b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037347b4"]])

export default __exports__